export { default as CloudDiagramsOnboarding } from "./CloudDiagramsOnboarding";
